// src/services/http.js
export function getApiBase() {
  const raw = import.meta.env?.VITE_API_URL || "http://localhost:8000/api";
  const clean = String(raw).replace(/\/+$/, "");
  return /\/api$/i.test(clean) ? clean : `${clean}/api`;
}

function withDefaults(options = {}) {
  const { method = "GET", headers = {}, body, token } = options;

  // Solo Content-Type cuando realmente hay body (evita preflight en GET/DELETE)
  const hasBody =
    body !== undefined && body !== null && method !== "GET" && method !== "DELETE";

  const finalHeaders = {
    ...(hasBody ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  };

  return {
    method,
    headers: finalHeaders,
    credentials: "include",
    body: hasBody ? JSON.stringify(body) : undefined,
  };
}

export async function apiFetch(path, options = {}) {
  const url = `${getApiBase()}${path}`;
  const res = await fetch(url, withDefaults(options));
  return res;
}

export async function apiJson(path, options = {}) {
  const res = await apiFetch(path, options);
  const ct = res.headers.get("content-type") || "";
  let data = null;
  if (res.status !== 204) {
    if (ct.includes("application/json")) {
      try { data = await res.json(); } catch { data = null; }
    } else {
      try { data = await res.text(); } catch { data = null; }
    }
  }
  if (!res.ok) {
    const msg = (data && (data.detail || data.message)) || res.statusText || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

// Interfaz path-primero (ya existente)
export const api = {
  get: (path, token) => apiJson(path, { method: "GET", token }),
  post: (path, body, token) => apiJson(path, { method: "POST", body, token }),
  patch: (path, body, token) => apiJson(path, { method: "PATCH", body, token }),
  delete: (path, token) => apiJson(path, { method: "DELETE", token }),
};

// ✅ Interfaz token-primero (compat con imports antiguos)
export const http = {
  get: (token, path) => api.get(path, token),
  post: (token, path, body) => api.post(path, body, token),
  patch: (token, path, body) => api.patch(path, body, token),
  delete: (token, path) => api.delete(path, token),
};

export default http;